import { staticSettings } from "@montana/helpers/static-settings.helper";
import { ISettings } from "@montana/models/generated/cms.interface";

import { createServiceFunction } from "../http";

export const fetchPageData = createServiceFunction(
    (path: string, productId?: string, customerType?: string, language?: string) => {
        const url = new URL(staticSettings.apiUrl + path);

        const headers: { [key: string]: string } = {};

        headers["Accept"] = "application/json";
        headers["Content-Type"] = "application/json";

        if (language) {
            headers["language"] = language;
        }

        if (customerType) {
            headers["CustomerType"] = customerType;
        }

        if (productId) {
            headers["productId"] = productId;
            url.searchParams.append("productId", productId + "");
        }

        return f =>
            f(url.href, {
                method: "GET",
                headers,
                redirect: "manual" //Handle redirects manually in entry-ssr.tsx from page.redirect attribute on local interface IPageContainerState
            });
    }
);

export const fetchPageDataAvailable = createServiceFunction(
    (path: string, productId?: string | null, customerType?: string) => {
        const url = new URL(staticSettings.apiUrl);

        if (productId) {
            url.pathname = '';
            url.searchParams.append("productId", productId);
        } else {
            url.pathname = path;
        }

        const headers: { [key: string]: string } = {};

        if (customerType) {
            headers["CustomerType"] = customerType;
        }

        return f =>
            f(url.href, {
                method: "HEAD",
                headers
            });
    }
);

export const fetchTranslations = createServiceFunction((language: string) => {
    const url = `${staticSettings.apiUrl}/api/translations/${language}`;

    return f =>
        f(`${url}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        });
});

export const fetchSiteStructure = createServiceFunction(
    (context: string, language: string) => {
        const url = `${staticSettings.apiUrl}/api/mainmenu/${context}/${language}`;

        return f =>
            f(url, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    language
                }
            });
    }
);

export const fetchGlobalSettings = async (
    language?: string,
    marketId?: string,
    customerType?: string
): Promise<ISettings> => {
    const url = `${staticSettings.apiUrl}/api/global-settings`;
    const headers = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        } as {[p: string]: string},
    };

    if (language) {
        (headers.headers as {[key: string]: string})["language"] = language;
    }

    if (marketId) {
        (headers.headers as {[key: string]: string})["marketId"] = marketId;
    }

    if (customerType) {
        (headers.headers as {[key: string]: string})["CustomerType"] = customerType;
    }

    const globalSettings: ISettings = await fetch(url, headers).then(res =>
        res.json()
    );

    return globalSettings;
};
